// ============================================================
// Storefront root domain (the suffix used for client subdomains).
// ============================================================
// Each tenant gets a subdomain on Gesty's root domain, eg.
//   tunielec.gesty.tn
//   client-x.gesty.tn
// All those subdomains point (via wildcard DNS *.gesty.tn) to the
// same Cloudflare Pages project running the storefront app, which
// routes by hostname.
//
// The actual root domain is configurable per build because:
//   - Khalil's agency uses gesty.tn
//   - Future agencies forking this could use any other domain
//   - Local dev / staging uses different roots
//
// Override at build/runtime by setting `VITE_STOREFRONT_ROOT_DOMAIN`.
// Falls back to "gesty.tn" when unset.

const FALLBACK = 'gesty.tn';

export function getStorefrontRootDomain(): string {
  const v = import.meta.env.VITE_STOREFRONT_ROOT_DOMAIN as string | undefined;
  const cleaned = v?.trim().toLowerCase().replace(/^\.+/, '').replace(/\/+$/, '');
  return cleaned && cleaned.length > 0 ? cleaned : FALLBACK;
}

export function getStorefrontEditorBaseUrl(): string {
  const v = import.meta.env.VITE_STOREFRONT_EDITOR_BASE_URL as string | undefined;
  const cleaned = v?.trim().replace(/\/+$/, '');
  return cleaned && cleaned.length > 0 ? cleaned : 'https://lyfty-storefront.pages.dev';
}

/** Builds the public URL of a tenant's storefront from its subdomain. */
export function storefrontSubdomainUrl(subdomain: string, scheme: 'https' | 'http' = 'https'): string {
  const sub = subdomain.trim();
  if (!sub) return '';
  return `${scheme}://${sub}.${getStorefrontRootDomain()}`;
}

/** Builds just the host portion (no scheme, no path) — useful for DNS instructions. */
export function storefrontSubdomainHost(subdomain: string): string {
  const sub = subdomain.trim();
  if (!sub) return '';
  return `${sub}.${getStorefrontRootDomain()}`;
}
